import { useCallback, useEffect } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter, useSearchParams } from 'src/routes/hooks';
//
import { PATH_AFTER_LOGIN, PATH_AFTER_LOGIN_DEVICE_ONLY, PATH_AFTER_LOGIN_IFTA_ONLY, PATH_AFTER_LOGIN_ELD_ONLY, PATH_AFTER_LOGIN_RENTALS_ONLY, PATH_AFTER_LOGIN_IS_PARENT } from 'src/config-global';
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const { authenticated, session } = useAuthContext();

  let pathAfterLogin = PATH_AFTER_LOGIN;

  if (session?.organization?.deviceOnly) {
    pathAfterLogin = PATH_AFTER_LOGIN_DEVICE_ONLY;
  } else if (session?.organization?.isParent) {
    pathAfterLogin = PATH_AFTER_LOGIN_IS_PARENT;
  } else if (session?.organization?.iftaOnly) {
    pathAfterLogin = PATH_AFTER_LOGIN_IFTA_ONLY;
  } else if (session?.organization?.eldOnly) {
    pathAfterLogin = PATH_AFTER_LOGIN_ELD_ONLY;
  } else if (session?.organization?.rentalsOnly) {
    pathAfterLogin = PATH_AFTER_LOGIN_RENTALS_ONLY;
  }

  // eslint-disable-next-line no-nested-ternary
  const returnTo = searchParams.get('returnTo') || pathAfterLogin;


  const check = useCallback(() => {
    if (authenticated) {
      router.replace(returnTo);
    }
  }, [authenticated, returnTo, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
